import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Input, Label } from 'reactstrap';
import { useEffect, useState } from 'react';
import '../assets/style/ViewGrievance.css';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from "react-redux";
import { docsUploadApi, docUploadApi, getFeedbackDetailsById, grievanceDetailsUpdateApi } from '../api/grievancesApi';
import { LoggedUserType } from '../utils/Types';
import { loginSelector } from "../redux/slices/loginSlice";
import { Box, Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import GrievanceDetails from '../pages/dashboard/components/GrievanceDetails';
import AdditionalInfo from '../pages/dashboard/components/AdditionalInfo';
import { checkNullValue, convertSeverityOptions, getCurrentDate, getCurrentTime, getIdByValue, getUpdateLobData } from '../utils/Util';
import { FormUtils } from '../utils/FormUtils';
import LabelField from '../components/LabelField';
import { toast } from 'react-toastify';
import { MAX_ATTACHMENT_SIZE, STATUS } from '../utils/Constant';
import FeedbackDetails from '../pages/dashboard/components/FeedbackDetail';
import { mapMasters } from '../utils/MastersMapping';
import { formattedDate } from '../utils/Util';

interface UpdateData {
  remarks: string;
  status: string | number;
  policyId: string;
  claimId: string;
  department: string | number;
  mode: string | number;
  source: string | number;
  spoc: string;
  intimationDate: string;
  resolutionDisposition: string;
  lob: string;
  request: string;
  referenceNumber: string;
  grievanceType: string | number;
  complaintDescription: string | number;
  isSeniorCitizen: boolean;
  doesNotPertain: boolean;
  doesNotPertainRemarks: string;
  duplicateNotes: string;
  claimReceivedAmount: string;
  dateOfHonoringService: string;
  insurerResolutionLetterdate: string;
  requestIRDAIForClosure: boolean;
  dateOfPayment: string;
  paymentChequeDate: string;
  paymentChequeNo: string;
  moveToFreshWorks: boolean;
  isFRRDocList: boolean;
  freshworkReferenceId: string;
  pincode: string;
  state: string;
  city: string
  severity: string;
}

const ViewGrievance = (props: any) => {
  const { toggle, openModal, grievance_id } = props
  const dispatch: any = useDispatch();
  const user: LoggedUserType = useSelector(loginSelector).user;
  const userName = user?.employeeName.split(':')[0]
  const {
    register,
    handleSubmit,
    watch,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm<UpdateData>()

  const updateData = useForm<UpdateData>({
    defaultValues: {
      status: '',
      remarks: '',
      policyId: '',
      claimId: '',
      department: '',
      mode: '',
      source: '',
      spoc: '',
      intimationDate: '',
      resolutionDisposition: '',
      lob: '',
      request: '',
      referenceNumber: '',
      grievanceType: '',
      complaintDescription: '',
      isSeniorCitizen: false,
      doesNotPertain: false,
      doesNotPertainRemarks: '',
      duplicateNotes: '',
      claimReceivedAmount: '',
      dateOfHonoringService: '',
      insurerResolutionLetterdate: '',
      requestIRDAIForClosure: false,
      dateOfPayment: '',
      paymentChequeDate: '',
      paymentChequeNo: '',
      moveToFreshWorks: false,
      isFRRDocList: false,
      freshworkReferenceId: '',
      pincode: '',
      state: '',
      city:'',
      severity: ''
    },
    mode: 'all',
  });

  const {
    storeGrievanceDetailsData,
    storeGrievanceDocUploadData,
    storeDepartmentData,
    storeGrievanceDescriptionData,
    storeComplaintModeData,
    storeComplaintSourceData,
    storeLOBData,
    storeRequesTypeData,
    storeFinalDispositionData,
    storeStatusData,
    storeDistrictMasterData,
    storeStateMasterData,
    storeSeverityData
  } = useSelector((state: any) => state.grievances);

  const grievanceDetailsData = storeGrievanceDetailsData.data ?? []
  const grievanceDocUploadResponseData = storeGrievanceDocUploadData.response ?? []
  const departmentData = FormUtils.convertDataList(
    storeDepartmentData.data ?? []
  );
  const complaintSourceData = FormUtils.convertDataList(
    storeComplaintSourceData.data ?? []
  );

  const complaintModeData = FormUtils.convertDataList(
    storeComplaintModeData.data ?? []
  );

  const lobList = getUpdateLobData(FormUtils.convertDataList(
    storeLOBData?.data ?? []
  ))

  const requestList = FormUtils.convertDataList(
    storeRequesTypeData.data ?? []
  )

  const resolutionDispositionData = FormUtils.convertDataList(
    storeFinalDispositionData.data ?? []
  );

  const statusData = FormUtils.convertDataList(
    storeStatusData?.data ?? []
  );

  const complaintDescriptionList = FormUtils.convertDataList(
    storeGrievanceDescriptionData?.data ?? []
  );
    
  const stateData = FormUtils.convertDataList(
    storeStateMasterData.data ?? []
  );
  const districtData = FormUtils.convertDataList(
    storeDistrictMasterData.data ?? []
  );
  const severityOptions = convertSeverityOptions(
    storeSeverityData.data?? []
  );
  const [submitData, setSubmitData] = useState<any>({});
  const [showAdditionalFields, setShowAdditionalFields] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState('1');
  const [image, setImage] = useState<any[]>([])

  const closeBtn = (
    <img src={require('../assets/img/close_modal.svg').default} style={{ cursor: 'pointer' }} onClick={() => { toggle(); props.setFlag(false) }}></img>
  );


  const onSubmit = (data: UpdateData) => {
    let honoringDate = data.dateOfHonoringService?.length > 0 ? data.dateOfHonoringService : '';
    let insurerResDate = data.insurerResolutionLetterdate?.length > 0 ? data.insurerResolutionLetterdate : '';
    let payDate = data.dateOfPayment?.length > 0 ? data.dateOfPayment : '';
    let payChDate = data.paymentChequeDate?.length > 0 ? data.paymentChequeDate : '';
    honoringDate = formattedDate(honoringDate);
    insurerResDate = formattedDate(insurerResDate);
    payDate = formattedDate(payDate);
    payChDate = formattedDate(payChDate);
    let intimation_date = data.intimationDate?.length > 0 ? data.intimationDate : getCurrentDate() + 'T' + getCurrentTime();
    let createdAt = `${intimation_date}:00`;
    const date: Date = new Date(createdAt);
    const formatDate: string = date.toISOString().replace('Z', '+00:00');
    let submitData = {
      ...data,
      createdAt: formatDate,
      dateOfHonoringService: honoringDate,
      insurerResolutionLetterdate: insurerResDate,
      dateOfPayment: payDate,
      paymentChequeDate: payChDate,
      complaintDescriptionId: complaintDescriptionList?.find((description: any) =>
        description?.label === data?.complaintDescription
      )?.value
    }
    setSubmitData(submitData);;

    if (image.length > 0) {
      const docsArray = image;
      const isFRRDocList = getValues('isFRRDocList');

      dispatch(docsUploadApi(grievance_id, docsArray, storeGrievanceDetailsData?.data?.grievanceModeBean?.grievanceModeId == 2 ? storeGrievanceDetailsData?.data?.referenceId : '', isFRRDocList));
    } else {
      updateApi(submitData);
    }
  };

  useEffect(() => {
    if (grievanceDocUploadResponseData === 'updated Successfully' || image.length === 0) {
      updateApi(submitData)
    }
  }, [storeGrievanceDocUploadData])

  const data = watch();
  useEffect(() => {
    if (activeTabIndex === '1') {
      reset(data);
    }
  }, [activeTabIndex])

  const updateApi = (data: any) => {
    const existingClaimReceivedAmount = storeGrievanceDetailsData?.data?.claimReceivedAmount;
    if (getValues('remarks')) {
      const body = {
        grievanceId: grievance_id,
        status: data?.status ? mapMasters(data?.status, statusData) : '',
        remarks: data?.remarks ? data?.remarks?.trim() : '',
        updatedBy: userName,
        severityId: data?.severity ? mapMasters(data?.severity, severityOptions) : null,
        policyNumber: data?.policyId && data?.policyId != 'N/A' ? data?.policyId?.trim() : '',
        claimId: data?.claimId && data?.claimId != 'N/A' ? data?.claimId?.trim() : '',
        grievanceType: data?.grievanceType ?? '',
        department: data?.department ? mapMasters(data?.department, departmentData) : '',
        spoc: data?.spoc && data?.spoc != 'N/A' ? data?.spoc : '',
        grievanceMode: data?.mode ? mapMasters(data?.mode, complaintModeData) : '',
        grievanceSource: data?.source ? mapMasters(data?.source, complaintSourceData) : '',
        createdAt: data?.intimationDate?.length > 0 ? data?.createdAt : '',
        lobId: data?.lob ? mapMasters(data?.lob, lobList) : '',
        typeOfRequest: data?.request ? mapMasters(data?.request, requestList) : '',
        finalDisposition: data?.resolutionDisposition && data?.resolutionDisposition != 'N/A' ? mapMasters(data?.resolutionDisposition, resolutionDispositionData) : null,
        referenceNumber: data?.referenceNumber ?? '',
        complaintDescriptionId: data?.complaintDescriptionId,
        isSeniorCitizen: data?.isSeniorCitizen,
        isDoesNotPertain: data?.doesNotPertain,
        isDoesNotPertainRemarks: data?.doesNotPertain && checkNullValue(data?.doesNotPertainRemarks) !== 'N/A' ? data?.doesNotPertainRemarks : '',
        originalIRDATokenNo: data?.duplicateNotes,
        claimReceivedAmount: existingClaimReceivedAmount ? existingClaimReceivedAmount : data?.claimReceivedAmount,
        dateOfHonoringService: data?.dateOfHonoringService && checkNullValue(data?.dateOfHonoringService) !== 'N/A' ? data?.dateOfHonoringService : '',
        insurerResolutionLetterdate: data?.insurerResolutionLetterdate && checkNullValue(data?.insurerResolutionLetterdate) !== 'N/A' ? data?.insurerResolutionLetterdate : '',
        requestIRDAIForClosure: data?.requestIRDAIForClosure,
        dateOfPayment: data?.dateOfPayment && checkNullValue(data?.dateOfPayment) !== 'N/A' ? data?.dateOfPayment : '',
        paymentChequeDate: data?.paymentChequeDate && checkNullValue(data?.paymentChequeDate) !== 'N/A' ? data?.paymentChequeDate : '',
        paymentChequeNo: data?.paymentChequeNo && checkNullValue(data?.paymentChequeNo) !== 'N/A' ? data?.paymentChequeNo : '',
        moveToFreshWorks: data?.moveToFreshWorks,
        isFRRDocList: data?.isFRRDocList,
        freshworkReferenceId: data?.freshworkReferenceId,
        grievanceAddress: {
          pincode: data?.pincode ?? null,
          addressLine1: data?.city ?? null,
          addressLine2: data?.state ?? null,
          districtId: getIdByValue(data?.city, districtData) ?? null,
          stateId: getIdByValue(data?.state, stateData) ?? null,
          villageId: null
        },
      }
      dispatch(grievanceDetailsUpdateApi(body));
    }
  }

  const raiseNewGrievance = () => {
    toggle();
    props.setOpenNewModal(true)
  }

  const selectTab = (event: any, value: string) => {
    setShowAdditionalFields(!showAdditionalFields);
    setActiveTabIndex(value);

    if (value === '3') {
      dispatch(getFeedbackDetailsById(
        storeGrievanceDetailsData?.data?.grievanceSourceBean?.grievanceSourceId === 2 ?
          storeGrievanceDetailsData?.data?.referenceId : grievance_id

      ));
    }
  }

  const setFile = (e: any) => {
    const files: File[] = Array.from(e.target.files || []);
    if (!files.length) return;

    const MAX_SIZE = 10 * 1024 * 1024;
    const validTypes = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
    const validExtensions = ['jpg', 'jpeg', 'png', 'pdf', 'msg', 'eml', 'doc', 'docx', 'xls', 'xlsx'];

    files.forEach((file) => {
      if (file.size > MAX_SIZE) {
        toast.warn(`${file.name} exceeds 10MB limit`);
        return;
      }

      const lastDotIndex = file.name.lastIndexOf('.');
      const fileExtension = lastDotIndex !== -1 ? file.name.substring(lastDotIndex + 1).toLowerCase() : '';

      if (!validTypes.includes(file.type) && !validExtensions.includes(fileExtension)) {
        toast.warn(`Invalid file type: ${file.name}`);
        return;
      }
      const reader = new FileReader();

      reader.onloadend = () => {
        const base64String = reader.result as string;

        if (!base64String || !base64String.includes(',')) {
          toast.warn(`Invalid file data: ${file.name}`);
          return;
        }

        setImage(prev => [...prev,
        {
          imageName: file.name,
          imageSize: file.size,
          imageType: fileExtension,
          imageBase64: base64String.split(',')[1]
        }
        ]);
      };

      reader.readAsDataURL(file);
    });

    e.target.value = '';
  };

  return (

    <Modal isOpen={openModal} toggle={toggle} centered={true} size='lg' backdrop={'static'} className="modal-size-custom2">
      <ModalHeader toggle={toggle} close={closeBtn}>View Grievance</ModalHeader>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
        <ModalBody>
          <TabContext value={activeTabIndex}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                value={activeTabIndex}
                onChange={selectTab}
                TabIndicatorProps={{
                  style: {
                    backgroundColor: 'rgba(92, 121, 170, 1)',
                    textTransform: 'none',
                  }
                }}
              >
                <Tab label="Update Grievance" value={'1'} className='tab' />
                <Tab label="Additional Fields" value={'2'} className='tab' />
                {user?.permissions?.includes('view-customer-feedback') && <Tab label="View Feedback" value={'3'} className='tab' />}
              </Tabs>
            </Box>
            <TabPanel value={'1'} sx={{ paddingBottom: '0' }}>
              <GrievanceDetails
                data={storeGrievanceDetailsData?.data}
                register={register}
                watch={watch}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                setImage={setImage}
                grievance_id={grievance_id}
                createdDate={props?.createdDate}
                closureDate={props?.closureDate}
              />
            </TabPanel>
            <TabPanel value={'2'}>
              <AdditionalInfo
                data={storeGrievanceDetailsData?.data}
                reopenDate={props?.reopenDate}
                tat={props?.tat}
              />
            </TabPanel>
            <TabPanel value={'3'}>
              <FeedbackDetails />
            </TabPanel>
          </TabContext>

          <div style={{ padding: '0 24px' }} className={activeTabIndex !== '1' ? 'input-file' : ''}>
            {/*  Upload Files*/}
            <Row className="align-items-start">
              <Col xs={6} md={7} className="mb-3">

                <LabelField
                  name="Upload Files"
                  required={
                    grievanceDetailsData?.grievanceStatus?.statusId === STATUS.REOPEN &&
                    (
                      mapMasters(watch('status'), statusData) === STATUS.RESOLVE ||
                      mapMasters(watch('status'), statusData) === STATUS.CLOSE
                    ) &&
                    (
                      grievanceDetailsData?.documents?.length > 0 ||
                      (getValues('isFRRDocList') && !grievanceDetailsData?.requestIRDAIForClosure === true)
                    )
                  }
                />

                <Input
                  type="file" id="fileUpload" multiple
                  accept=".jpg,.jpeg,.png,.pdf,.msg,.eml,.doc,.docx,.xls,.xlsx"
                  onChange={setFile}
                  hidden
                />
                <Button
                  color="secondary"
                  size="sm"
                  onClick={() =>
                    document.getElementById('fileUpload')?.click()
                  }
                  disabled={grievanceDetailsData?.freshworkReferenceId && !grievanceDetailsData?.freshworkToGrdsSync}
                >
                  Choose Files
                </Button>

                {/* FILE LIST */}
                {image.length > 0 && (
                  <div
                    className="mt-3 border rounded p-2 bg-light overflow-auto"
                    style={{ maxHeight: '150px' }}
                  >
                    {image.map((file, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center justify-content-between border rounded px-2 py-1 mb-1 bg-white"
                        style={{ fontSize: '13px' }}
                      >
                        <span
                          className="text-truncate"
                          style={{ maxWidth: '85%' }}
                        >
                          {file.imageName}
                        </span>

                        <Button
                          close
                          aria-label="Remove file"
                          className="bg-danger rounded-circle p-1"
                          onClick={() =>
                            setImage(prev =>
                              prev.filter((_, i) => i !== index)
                            )
                          }
                        />
                      </div>
                    ))}
                  </div>
                )}

                <Label className="d-flex error-msg">
                  *Maximum file size supported: {MAX_ATTACHMENT_SIZE}
                </Label>

              </Col>
            </Row>
          </div>
        </ModalBody>

        <ModalFooter>
          {(grievanceDetailsData?.freshworkReferenceId && grievanceDetailsData?.freshworkToGrdsSync ==false) ?  (
  // Case 1: Freshworks ID exists → just show it (no buttons)
  <p className='d-flex justify-content-center'>
    This ticket has already been moved to Freshworks
     <img 
              src={require('../assets/img/download.jpeg')}
              style={{width:"4%",height: "8%"}}
            />
  </p>
) : (
  // Case 2: No Freshworks ID → show validated buttons
  <>
    {grievanceDetailsData?.grievanceStatus?.statusId !== STATUS.CLOSE ? (
      <>
        <Button
          type="submit"
          className="button"
          style={{ width: '91px' }}
          disabled={
            !getValues('remarks')?.trim() ||
            /^\s*$/.test(getValues('remarks')) ||
            (
              getValues('isFRRDocList') === true &&
              !grievanceDetailsData?.requestIRDAIForClosure &&
              (image?.length ?? 0) === 0
            )
          }
        >
          Submit
        </Button>{' '}
        <Button
          onClick={() => {
            toggle();
            props.setFlag(false);
          }}
          className="resetButton"
          style={{ width: '91px' }}
        >
          Cancel
        </Button>
      </>
    ) : (
      <>
        <Button
          type="submit"
          className="button"
          style={{ width: '91px' }}
          disabled={!((getValues('remarks') ?? '').trim().length > 0)}
        >
          Submit
        </Button>{' '}
        <Button
          onClick={() => { raiseNewGrievance(); }}
          className="resetButton"
          style={{ width: '191px' }}
          disabled={!user?.permissions?.includes('create-grievance')}
        >
          Raise New Grievance
        </Button>
      </>
    )}
  </>
)}

        </ModalFooter>
      </form>
    </Modal>
  );
}


export default ViewGrievance;